function SwipeHint(containerObject){
	/* THIS FIX */
	var _this = this;
	
	/* PRIVATE CONSTANTS */
	var HIDE_DELAY = 1200;
	var TRANSITION_DURATION = 500 + 200; // from CSS
	
	
	/* PRIVATE VARIABLES */
	var rellax;
	var hint;
	var showTriggered = false;
	

	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;
	
	
	/* PRIVATE FUNCTIONS */
	function _construct(){
		_this.container = containerObject;
		_this.init();
	}


	function hide() {
		hint.removeClass('visible');
		setTimeout(_this.destroy, TRANSITION_DURATION);
	}
	
	
	/* PUBLIC FUNCTIONS */	
	this.init = function(){
		if(!_this.inited){	
			
			hint = $('<div class="swipe-hint"><span></span></div>');
			_this.container.append(hint);
			// use Rellax to detect scroll
			rellax = new Rellax('.swipe-hint span', {
				callback: function (positions) {
					if(!showTriggered && isInViewport(hint[0])) {
						showTriggered = true;
						hint.addClass('visible');
						setTimeout(hide, HIDE_DELAY);
					}
				}
			});

			_this.inited = true;
		}
	};
	
	
	this.destroy = function(){
		if(rellax) {
			rellax.destroy();
		}
		if(hint) {
			hint.remove();
		}
	};
	
		

	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
